export default __webpack_public_path__ + "static/media/razorpay.3373ea00.webp";